export default __webpack_public_path__ + "static/media/you-active.f4e0e927.svg";